export const ROUTES = {
    HOMEPAGE: "/",
    TERMS_OF_USE: "/terms-of-use",
    PRIVACY_POLICY: "/privacy-policy",
    COOKIES_POLICY: "/cookies-policy",
    STACKING: '/staking',
    UN_STACKING: '/un-staking',
    WITHDRAW: "/withdraw"
};